import { getLocale } from "../runtime";

const sv_nutrition = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Näring`
};

const nutrition = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_nutrition(inputs)
	return "nutrition";
};

export { nutrition as "nutrition" };